import { render, staticRenderFns } from "./BatchSale.vue?vue&type=template&id=5c94c46e&"
import script from "./BatchSale.vue?vue&type=script&lang=js&"
export * from "./BatchSale.vue?vue&type=script&lang=js&"
import style0 from "./BatchSale.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports